import * as ActiveStorage from "@rails/activestorage"
import "@hotwired/turbo-rails"
import { Application } from "@hotwired/stimulus"
import { StimulusLoader } from "@app/stimulus_loader";
import '@js/inspinia/config'

window.activeStorage  = ActiveStorage.start();
window.application    = Application.start();

window.adminPage = new StimulusLoader({
  controllers: import.meta.glob("@app/controllers/devise_auth/*_controller.js", { eager: true }),
  controllers: import.meta.glob("@app/controllers/store_page/checkout_otp_controller.js", { eager: true }),
});
window.adminPage.registerControllers();
